import React from 'react'
import styled from '@emotion/styled'

import { Text } from '../Text/Text'

export interface ChoiceChipProps {
  children: React.ReactNode
  active?: boolean
  disabled?: boolean
  nowrap?: boolean
  size?: 'xs' | 's' | 'm' | 'l'
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
}

export const ChoiceChip: React.FC<ChoiceChipProps> = ({
  children,
  active = false,
  disabled = false,
  nowrap = false,
  size = 'l',
  onClick,
  ...props
}) => {
  return (
    <StyledChoiceChip
      disabled={disabled}
      active={active}
      nowrap={nowrap}
      onClick={onClick}
      size={size}
      {...props}
    >
      <Text weight="stronger">{children}</Text>
    </StyledChoiceChip>
  )
}

export const StyledChoiceChip = styled('button')<ChoiceChipProps>`
  cursor: pointer;
  padding: ${(props) => `var(--space-inset-squish--${props.size})`};
  background: var(--choice-chip-bg--default);
  font-size: var(--font-size--base);
  border-radius: var(--border-radius--l);
  border: 1px solid var(--choice-chip-border--default);
  ${(p) => {
    if (p.nowrap) {
      return `
         max-width: max-content;
        `
    } else {
      return `
          max-width: fit-content;
        `
    }
  }}
  span {
    color: var(--choice-chip-text--default);
  }
  ${(p) => {
    if (p.active && !p.disabled) {
      return `
          background: var(--choice-chip-bg--active);
          border-color: var(--choice-chip-border--active);

          span {
            color: var(--choice-chip-text--active);
          }
        `
    } else if (p.disabled) {
      return `
          cursor: not-allowed;
          background: var(--choice-chip-bg--disabled);
          border-color: var(--choice-chip-border--disabled);

          span {
            color: var(--choice-chip-text--disabled);
          }
        `
    }
  }}

  ${(p) =>
    !p.active &&
    !p.disabled &&
    `
      &:hover {
        span {
          color: var(--choice-chip-hover--default);
        }
      }
    `}
`
